import axios from 'axios';
import { openKnotsCopy } from '../../utils/constants/openKnotsLabel';

const baseUrl = () => process.env.REACT_APP_USER_MANAGEMENT;

const headers = { 'content-type': 'application/json' };

const stringifyErrorListItem = (item) =>
    typeof item === 'string' ? item : item?.message || item?.error || JSON.stringify(item);

const messageFromErrorData = (data) => {
    if (typeof data === 'string' && data.trim()) {
        return data.trim();
    }
    if (!data || typeof data !== 'object') {
        return null;
    }
    const fromBody =
        data.serviceMessage ||
        data.message ||
        data.errorMessage ||
        data.error_description ||
        (typeof data.error === 'string' ? data.error : null) ||
        data.detail ||
        data.title ||
        (typeof data.payload === 'string' ? data.payload : null) ||
        data.payload?.message ||
        data.payload?.serviceMessage;

    if (fromBody) {
        return String(fromBody);
    }

    if (Array.isArray(data.errors) && data.errors.length > 0) {
        return data.errors.map(stringifyErrorListItem).join(', ');
    }
    return null;
};

/**
 * Extracts a user-visible message from API error responses (axios or isSuccess: false).
 */
export const getIamApiErrorMessage = (error, fallback = 'Request failed') => {
    if (!error) return openKnotsCopy(fallback);

    if (typeof error.message === 'string' && error.message && !error.response && !error.data) {
        return openKnotsCopy(error.message);
    }

    const fromData = messageFromErrorData(error?.response?.data ?? error?.data);
    if (fromData) {
        return openKnotsCopy(fromData);
    }

    if (error?.message && error.message !== 'Network Error') {
        return openKnotsCopy(error.message);
    }

    const status = error?.response?.status ?? error?.responseCode ?? error?.status;
    if (status) {
        return openKnotsCopy(`${fallback} (HTTP ${status})`);
    }

    return openKnotsCopy(fallback);
};

export const toIamRejectPayload = (error) => ({
    message: getIamApiErrorMessage(error, 'Request failed'),
    status: error?.status ?? error?.response?.status ?? error?.responseCode,
});

/** Reads serviceMessage from thunk fulfilled payload ({ payload, serviceMessage }). */
export const getIamSuccessMessage = (value, fallback = null) => {
    if (!value) return openKnotsCopy(fallback);
    if (typeof value === 'string' && value.trim()) return openKnotsCopy(value.trim());
    if (typeof value !== 'object') return openKnotsCopy(fallback);
    const msg = value.serviceMessage ?? value.payload?.serviceMessage;
    if (msg != null && String(msg).trim()) return openKnotsCopy(String(msg).trim());
    if (typeof value.payload === 'string' && value.payload.trim()) {
        return openKnotsCopy(value.payload.trim());
    }
    return openKnotsCopy(fallback);
};

export const iamRequest = async (config) => {
    const response = await axios({ ...config, headers: { ...headers, ...config.headers } });
    const data = response?.data;
    if (data?.isSuccess === false) {
        const err = {
            response,
            data,
            status: data?.responseCode ?? response?.status,
        };
        throw err;
    }
    return {
        payload: data?.payload,
        serviceMessage: data?.serviceMessage,
    };
};

export const iamBaseUrl = baseUrl;
